function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#59178a",
  d: "M462.4926,66.0136c0-24.1829-19.6741-43.8573-43.8569-43.8573H66.3651c-24.1828,0-43.8576,19.6744-43.8576,43.8573v352.2706c0,24.1828,19.6748,43.8576,43.8576,43.8576h352.2706c24.1828,0,43.8569-19.6748,43.8569-43.8576V66.0136ZM440.7657,418.2841c0,12.2032-9.9276,22.1307-22.13,22.1307H66.3651c-12.2032,0-22.1308-9.9275-22.1308-22.1307V66.0136c0-12.2029,9.9276-22.1304,22.1308-22.1304h352.2706c12.2024,0,22.13,9.9275,22.13,22.1304v352.2706Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M418.6357,22.1563c24.1828,0,43.8569,19.6744,43.8569,43.8573v352.2706c0,24.1828-19.6741,43.8576-43.8569,43.8576H66.3651c-24.1828,0-43.8576-19.6748-43.8576-43.8576V66.0136c0-24.1829,19.6748-43.8573,43.8576-43.8573h352.2706M66.3651,440.4149h352.2706c12.2024,0,22.13-9.9275,22.13-22.1307V66.0136c0-12.2029-9.9276-22.1304-22.13-22.1304H66.3651c-12.2032,0-22.1308,9.9275-22.1308,22.1304v352.2706c0,12.2032,9.9276,22.1307,22.1308,22.1307M418.6357.4294H66.3651C30.2017.4294.7806,29.8504.7806,66.0136v352.2706c0,36.1634,29.4211,65.5845,65.5845,65.5845h352.2706c36.163,0,65.5838-29.4211,65.5838-65.5845V66.0136C484.2194,29.8504,454.7987.4294,418.6357.4294h0Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#59178a",
  d: "M76.959,418.688h331.0819c6.0488,0,10.9979-4.949,10.9979-10.9979v-56.2497H65.9612v56.2497c0,6.0488,4.949,10.9979,10.9979,10.9979Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#59178a",
  d: "M408.041,61.662H76.959c-6.0488,0-10.9979,4.949-10.9979,10.9979v211.532h353.0776V72.6599c0-6.0488-4.949-10.9979-10.9979-10.9979Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#59178a",
  d: "M178.5443,315.5996l-4.8869-1.3496c-1.3132-.3645-2.1763-.8078-2.5893-1.3306-.4137-.5229-.6199-1.1003-.6199-1.733,0-.826.3766-1.4822,1.1306-1.9687.7532-.4865,1.7626-.7297,3.0265-.7297,1.4587,0,2.656.3046,3.5926.9116.9359.6085,1.5254,1.5565,1.7686,2.8447h5.3976c-.2432-2.3824-1.2761-4.2973-3.1001-5.7439-1.8232-1.4466-4.267-2.1703-7.3307-2.1703-1.9937,0-3.732.3107-5.215.9305s-2.6317,1.5072-3.4464,2.6621-1.2215,2.5226-1.2215,4.1026c0,1.8482.5774,3.3865,1.7323,4.6141,1.1541,1.2276,2.9841,2.1945,5.4886,2.8992l4.8869,1.3496c1.1912.316,2.0301.735,2.5166,1.2579s.7297,1.2094.7297,2.0604c0,.9002-.4077,1.6171-1.2223,2.1521s-1.9755.8025-3.4827.8025c-1.8482,0-3.3675-.4069-4.5588-1.2223-1.1912-.8138-1.8725-1.9263-2.0422-3.3365h-5.3976c.3402,2.7712,1.5315,4.9172,3.5744,6.4365,2.0422,1.5201,4.7649,2.2794,8.1688,2.2794,3.2577,0,5.7992-.7047,7.6224-2.1149s2.7356-3.4282,2.7356-6.0546c0-1.8717-.5653-3.4213-1.6959-4.6497-1.1306-1.2276-2.9849-2.1938-5.5621-2.8992Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#59178a",
  d: "M195.7473,306.1904l-5.4704,2.0422v4.1579h-3.4645v4.1571h3.4645v7.8414c0,2.3582.5774,4.1155,1.7323,5.2696,1.1548,1.1556,2.9235,1.7323,5.3067,1.7323.7047,0,1.3428-.0485,1.9141-.1455.5714-.0978,1.0154-.2311,1.3314-.4016v-4.1571c-.316.097-.6327.1826-.948.2554-.3167.0727-.657.1091-1.0215.1091-.973,0-1.6898-.2061-2.1513-.6199-.4622-.413-.6934-1.0328-.6934-1.8603v-8.0233h4.8141v-4.1571h-4.8141v-6.2001Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#59178a",
  d: "M219.6452,327.161v-8.2059c0-2.2369-.7055-3.951-2.1149-5.1422-1.411-1.1912-3.4532-1.7876-6.1274-1.7876-2.5772,0-4.608.5471-6.0902,1.6413-1.4837,1.0942-2.3468,2.4802-2.5893,4.1579h5.215c.1697-.6077.5289-1.07,1.076-1.386s1.2822-.4744,2.2059-.4744c.9722,0,1.708.2137,2.2066.6388.4979.4251.7479,1.0154.7479,1.7686v.9571l-4.5951.6471c-2.3339.3167-4.1518,1.0033-5.4522,2.0611-1.3011,1.0571-1.9513,2.4491-1.9513,4.1753,0,1.5565.5471,2.803,1.6406,3.7381,1.0942.9366,2.5651,1.4042,4.4133,1.4042,1.58,0,2.9174-.3524,4.0117-1.0571.8832-.5695,1.5748-1.3716,2.0937-2.384.0136.492.0356.9571.0765,1.3625.0599.6077.1637,1.1799.3099,1.7141h5.4704c-.1947-.7047-.3342-1.3678-.4198-1.9876-.0849-.6199-.1273-1.2337-.1273-1.8414ZM212.9715,326.4131c-.8025.6199-1.7755.9298-2.9182.9298-.729,0-1.3125-.1576-1.7505-.4736-.4372-.316-.6562-.7782-.6562-1.386,0-.6805.2304-1.2155.6926-1.605.4615-.3887,1.1791-.6562,2.1521-.8025l3.6835-.5642v1.7311c0,.8267-.4016,1.5504-1.2033,2.1703Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#59178a",
  d: "M235.1742,312.0252c-1.727,0-3.1789.4077-4.358,1.2223-.9688.6689-1.7336,1.5326-2.3165,2.57v-3.427h-5.3605v18.5995h5.4704v-9.9928c0-.9237.1879-1.7262.5653-2.4074.3766-.6797.8995-1.2155,1.5678-1.6042s1.4284-.5835,2.2794-.5835c.9972,0,1.7565.2554,2.2794.7654.5229.5107.7843,1.2768.7843,2.2983v11.5242h5.4704v-12.5821c0-1.9452-.5471-3.4949-1.6406-4.6497-1.0942-1.1548-2.6749-1.733-4.7414-1.733Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#59178a",
  d: "M258.3257,315.2576c-.3342-.7856-.8372-1.4589-1.5504-1.9919-1.1063-.8267-2.5469-1.2405-4.3216-1.2405-1.702,0-3.191.4016-4.4678,1.2041-1.2761.8017-2.2673,1.9323-2.972,3.3918-.7055,1.4587-1.0579,3.1728-1.0579,5.1422,0,1.9452.3402,3.635,1.0215,5.0687.6805,1.4352,1.6466,2.5476,2.8992,3.3372,1.2518.7904,2.7287,1.1852,4.4307,1.1852,1.6777,0,3.1182-.4009,4.3223-1.2033.8345-.5565,1.4324-1.2445,1.805-2.0579v2.8968h5.3612v-26.2584h-5.4704v10.5259ZM257.1951,325.6106c-.8025.9116-1.8482,1.3678-3.1364,1.3678-1.3132,0-2.3771-.4494-3.1917-1.3496-.8146-.8987-1.2215-2.1998-1.2215-3.9025,0-1.7012.4069-3.0144,1.2215-3.9381s1.8543-1.386,3.1182-1.386c1.3132,0,2.3764.4554,3.191,1.3678.8146.9116,1.2223,2.2188,1.2223,3.92,0,1.7027-.4016,3.0091-1.2033,3.9207Z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#59178a",
  d: "M283.9923,327.161v-8.2059c0-2.2369-.7055-3.951-2.1149-5.1422-1.411-1.1912-3.4532-1.7876-6.1274-1.7876-2.5772,0-4.608.5471-6.0902,1.6413-1.4837,1.0942-2.3468,2.4802-2.5893,4.1579h5.215c.1697-.6077.5289-1.07,1.076-1.386s1.2822-.4744,2.2059-.4744c.9722,0,1.708.2137,2.2066.6388.4979.4251.7479,1.0154.7479,1.7686v.9571l-4.5951.6471c-2.3339.3167-4.1518,1.0033-5.4522,2.0611-1.3011,1.0571-1.9513,2.4491-1.9513,4.1753,0,1.5565.5471,2.803,1.6406,3.7381,1.0942.9366,2.5651,1.4042,4.4133,1.4042,1.58,0,2.9174-.3524,4.0117-1.0571.8832-.5695,1.5748-1.3716,2.0937-2.384.0136.492.0356.9571.0765,1.3625.0599.6077.1637,1.1799.3099,1.7141h5.4704c-.1947-.7047-.3342-1.3678-.4198-1.9876-.0849-.6199-.1273-1.2337-.1273-1.8414ZM277.3185,326.4131c-.8025.6199-1.7755.9298-2.9182.9298-.729,0-1.3125-.1576-1.7505-.4736-.4372-.316-.6562-.7782-.6562-1.386,0-.6805.2304-1.2155.6926-1.605.4615-.3887,1.1791-.6562,2.1521-.8025l3.6835-.5642v1.7311c0,.8267-.4016,1.5504-1.2033,2.1703Z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#59178a",
  d: "M294.6344,313.2657c-.7585.629-1.3528,1.4787-1.7876,2.5435v-3.4187h-5.3605v18.5995h5.4704v-9.701c0-1.5072.413-2.5711,1.2397-3.191s2.1157-.9305,3.8662-.9305c.3152,0,.5835.0068.8025.0189.2182.0121.388.0424.51.0909v-5.1059c-.2182-.097-.5592-.1463-1.0207-.1463-1.4837,0-2.7234.4137-3.7199,1.2405Z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#59178a",
  d: "M314.5184,304.7317v10.5259c-.3342-.7856-.8372-1.4589-1.5504-1.9919-1.1063-.8267-2.5469-1.2405-4.3216-1.2405-1.702,0-3.191.4016-4.4678,1.2041-1.2761.8017-2.2673,1.9323-2.972,3.3918-.7055,1.4587-1.0579,3.1728-1.0579,5.1422,0,1.9452.3402,3.635,1.0215,5.0687.6805,1.4352,1.6466,2.5476,2.8992,3.3372,1.2518.7904,2.7287,1.1852,4.4307,1.1852,1.6777,0,3.1182-.4009,4.3223-1.2033.8345-.5565,1.4324-1.2445,1.805-2.0579v2.8968h5.3612v-26.2584h-5.4704ZM313.3878,325.6106c-.8025.9116-1.8482,1.3678-3.1364,1.3678-1.3132,0-2.3771-.4494-3.1917-1.3496-.8146-.8987-1.2215-2.1998-1.2215-3.9025,0-1.7012.4069-3.0144,1.2215-3.9381s1.8543-1.386,3.1182-1.386c1.3132,0,2.3764.4554,3.191,1.3678.8146.9116,1.2223,2.2188,1.2223,3.92,0,1.7027-.4016,3.0091-1.2033,3.9207Z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M402.5392,159.9289c-.0035,1.2621-.3297,2.4396-.9783,3.5326-.6488,1.093-1.5346,1.955-2.6573,2.5856-1.1231.6306-2.3359.9443-3.639.9408-1.2973-.0036-2.5057-.324-3.6251-.9607-1.1194-.6368-2.0004-1.5037-2.643-2.6002-.6428-1.0965-.9623-2.2759-.9589-3.5379.0027-.986.1933-1.9085.5713-2.7675.3778-.859.9039-1.6115,1.5777-2.2587.674-.6464,1.4546-1.1507,2.3419-1.512.8872-.3613,1.8123-.5411,2.7752-.5384.98.0027,1.9144.1876,2.8028.5538s1.6631.8703,2.3248,1.5116c.6614.6421,1.1788,1.3931,1.5521,2.2541.3733.8611.5587,1.7934.556,2.797ZM400.7346,159.7658c.0021-.7574-.1354-1.4606-.4123-2.1101-.2772-.6494-.6658-1.2243-1.1664-1.7246-.5004-.5003-1.0848-.889-1.7532-1.1674-.6684-.2775-1.3636-.4173-2.0856-.4192-.7163-.002-1.4107.1357-2.0837.4122-.6728.2773-1.2564.6589-1.7508,1.1446-.4946.4857-.885,1.0615-1.1715,1.727-.2865.6655-.4307,1.3679-.4327,2.1078-.0027.9855.237,1.8951.7189,2.727.4819.8319,1.1376,1.4907,1.9668,1.9774.8292.4867,1.737.7314,2.7232.7341.9917.0027,1.9037-.2387,2.7358-.7235.8319-.4848,1.4912-1.1417,1.9776-1.9709s.7312-1.7339.7339-2.7142ZM398.7085,163.3436l-2.1131-.0058c-.3853-.8052-.7196-1.4416-1.003-1.9091-.2834-.4676-.5041-.7483-.6624-.8425-.1759-.0828-.387-.1244-.6336-.125l-.0079,2.8703-1.7875-.0049.0198-7.2022,3.2138.0088c.7982.0022,1.4303.1669,1.896.494.4659.3267.6976.8457.6957,1.5555-.0018.6403-.2025,1.1092-.6026,1.4075-.4.2979-.8524.4935-1.3575.5859.3928.1772.6958.4027.9095.6758.2135.2736.4691.6927.767,1.2572l.6657,1.2344ZM396.486,158.2833c.0008-.3047-.1205-.5314-.3636-.6787s-.5673-.2217-.9722-.2229l-.8453-.0023-.0049,1.7963.7748.0021c.4578.0013.8072-.0669,1.0482-.2041s.3621-.3672.363-.6904Z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M82.4612,194.6322c.066-24.2573,18.1336-42.9293,43.0972-42.861,15.0724.0414,28.4759,7.7321,35.6248,19.6447l-18.2791,10.4307c-3.1642-5.8975-9.7479-9.4479-17.4016-9.4692-13.3061-.0369-22.0456,9.1245-22.0814,22.3131-.0369,13.1886,8.6521,22.3959,21.9582,22.4328,7.6537.0213,14.2575-3.4933,17.4531-9.4893l18.2221,10.6478c-7.2149,11.8734-20.5423,19.4902-35.7322,19.4488-24.9635-.0683-42.9282-18.841-42.861-43.0983Z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  opacity: 0.99,
  d: "M234.0099,153.8352l-.2261,82.4268-20.9598-.0571.0862-31.6759-23.1973-.0638-.0862,31.6759-21.0785-.0582.2261-82.4268,21.0785.0582-.0839,30.4973,23.1973.0638.0839-30.4973,20.9598.0571Z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M293.639,224.5329l-27.4372-.075-3.5649,11.8835-22.8436-.0627,27.4271-82.3518,25.6698.0705,26.9749,82.5018-22.7261-.0627-3.5-11.9037ZM288.2709,206.3847l-8.2828-28.0472-8.3197,28.0013,16.6024.0459Z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M319.8271,217.7769l18.0441-10.4307c2.9247,7.0728,7.9772,10.9735,16.2196,10.9959,7.4187.0201,9.6628-2.6818,9.6707-5.508.0134-4.71-5.3995-6.1393-15.8715-9.111-12.9412-3.8034-24.4632-10.4307-24.4207-25.8556.0425-15.4261,12.6681-25.5176,28.6829-25.4728,13.6598.0369,24.8292,6.5445,30.5645,18.9239l-17.6915,10.3143c-2.5732-6.1304-6.8042-9.2039-12.8103-9.2207-5.1812-.0146-7.6604,2.4524-7.6683,5.3961-.0101,3.65,2.9281,5.6591,14.1053,8.9879,12.7073,3.8034,26.2362,8.5503,26.1892,25.8601-.0459,16.3674-12.789,25.7526-31.3939,25.7012-17.8986-.0492-29.2974-8.4406-33.6201-20.5804Z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M317.7028,107.3287c-.0013.46-.1202.8892-.3566,1.2876-.2365.3984-.5593.7126-.9685.9424-.4094.2298-.8514.3442-1.3263.3429-.4729-.0013-.9133-.1181-1.3213-.3502s-.7291-.5481-.9633-.9477c-.2343-.3997-.3508-.8295-.3495-1.2895.001-.3594.0705-.6956.2082-1.0087.1377-.3131.3295-.5874.575-.8233.2457-.2356.5302-.4194.8536-.5511s.6606-.1972,1.0115-.1962c.3572.001.6978.0684,1.0216.2018s.6062.3172.8473.5509c.2411.234.4296.5077.5657.8216.136.3138.2037.6537.2026,1.0195ZM317.045,107.2692c.0008-.2761-.0493-.5324-.1503-.7691-.101-.2367-.2427-.4462-.4251-.6286-.1824-.1824-.3954-.324-.639-.4255-.2436-.1011-.497-.1521-.7601-.1528-.2611-.0007-.5142.0495-.7595.1502-.2452.1011-.4579.2401-.6381.4172-.1803.177-.3226.3869-.427.6295s-.157.4986-.1577.7682c-.001.3592.0864.6907.262.9939s.4146.5433.7169.7207.6331.2666.9926.2676c.3615.001.6939-.087.9972-.2637.3032-.1767.5435-.4161.7208-.7184s.2665-.632.2675-.9893ZM316.3065,108.5733l-.7702-.0021c-.1404-.2935-.2623-.5254-.3656-.6958s-.1838-.2727-.2414-.3071c-.0641-.0302-.141-.0453-.2309-.0456l-.0029,1.0462-.6515-.0018.0072-2.6251,1.1714.0032c.2909.0008.5213.0608.6911.1801.1698.1191.2543.3082.2536.567-.0006.2334-.0738.4043-.2196.513-.1458.1086-.3107.1799-.4948.2136.1432.0646.2536.1468.3315.2463.0778.0997.171.2525.2795.4582l.2427.4499ZM315.4965,106.7289c.0003-.1111-.0439-.1937-.1325-.2474s-.2068-.0808-.3543-.0812l-.3081-.0008-.0018.6547.2824.0008c.1668.0005.2942-.0244.3821-.0744s.132-.1338.1323-.2516Z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M197.1093,124.9231c2.224.0061,3.8947-.9901,4.788-2.2851l3.2938,1.9366c-1.7121,2.516-4.4964,4.0279-8.1289,4.0179-6.1162-.0168-10.0709-4.2163-10.0556-9.7765.0151-5.4861,3.993-9.7378,9.8126-9.7218,5.5231.0152,9.2917,4.4736,9.277,9.8113-.0015.5561-.0772,1.1489-.1529,1.6678l-14.7528-.0406c.6222,2.8929,2.9534,4.3821,5.9188,4.3903ZM202.0604,117.3007c-.5473-3.1893-2.8788-4.5673-5.2882-4.5739-3.0024-.0083-5.0462,1.7654-5.6097,4.5439l10.8978.03Z"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M221.8032,109.6449l4.0032.011-.051,18.5338-4.0032-.011.051-18.5338Z"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M235.4417,109.3472l-.001.3707,4.0549.0112-.0106,3.8551-4.0549-.0112-.0404,14.6787-4.0032-.011.0404-14.6787-2.4175-.0067.0106-3.8551,2.4175.0067.001-.3707c.0138-5.0041,2.5198-7.8885,8.0789-7.5025l-.0106,3.8551c-2.8164-.2672-4.0572.8043-4.065,3.6584Z"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M240.6789,118.9993c.0152-5.5231,4.4008-9.7367,9.8126-9.7218,5.449.015,9.7743,4.2526,9.7591,9.7756-.0151,5.4861-4.3637,9.7368-9.8128,9.7218-5.4118-.0149-9.774-4.2896-9.7589-9.7756ZM256.2471,119.0422c.0093-3.3731-2.5043-5.8637-5.7664-5.8727-3.2618-.009-5.7893,2.4677-5.7986,5.8409-.0093,3.3731,2.5045,5.8637,5.7664,5.8727,3.2621.009,5.7893-2.4677,5.7986-5.8409Z"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M272.5351,109.4865l-.0119,4.3369c-2.6312-.1926-5.6694,1.0222-5.6809,5.1738l-.0257,9.341-4.0032-.011.051-18.5339,4.0032.011-.0086,3.1137c1.119-2.5176,3.3408-3.438,5.6761-3.4316Z"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M218.5809,109.3026l-.0119,4.3369c-2.6312-.1926-5.6694,1.0222-5.6809,5.1738l-.0257,9.341-4.0032-.011.051-18.5339,4.0032.011-.0086,3.1137c1.119-2.5176,3.3408-3.438,5.6761-3.4316Z"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M273.6725,119.0546c.0152-5.5231,4.2154-9.7372,9.8126-9.7218,3.6325.01,6.7781,1.909,8.253,4.8044l-3.4529,1.9921c-.8107-1.7445-2.6239-2.8614-4.8479-2.8675-3.2621-.009-5.7523,2.4676-5.7615,5.8037-.0092,3.3361,2.4674,5.8266,5.7294,5.8355,2.224.0061,4.0434-1.138,4.9379-2.8408l3.4418,1.9741c-1.5649,2.9241-4.7209,4.8058-8.3534,4.7958-5.5971-.0154-9.774-4.2896-9.7589-9.7756Z"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M303.6871,125.2164c2.224.0061,3.8947-.9901,4.788-2.2851l3.2938,1.9366c-1.7121,2.516-4.4964,4.0279-8.1289,4.0179-6.1162-.0168-10.0709-4.2163-10.0556-9.7765.0151-5.4861,3.993-9.7378,9.8126-9.7218,5.5231.0152,9.2917,4.4736,9.277,9.8113-.0015.5561-.0772,1.1489-.1529,1.6678l-14.7528-.0406c.6222,2.8929,2.9534,4.3821,5.9188,4.3903ZM308.6381,117.594c-.5473-3.1893-2.8788-4.5673-5.2882-4.5739-3.0024-.0083-5.0462,1.7654-5.6097,4.5439l10.8978.03Z"
});

var _ref28 =
/*#__PURE__*/
React.createElement("rect", {
  fill: "#fff",
  x: 221.8177,
  y: 102.398,
  width: 4.0032,
  height: 4.0032,
  transform: "translate(118.8041 327.9308) rotate(-89.8423)"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M181.5382,109.5341l-.0005.173c-.1073,2.8077-.8974,9.7739-5.7052,14.0094-1.0827-.9645-1.9498-2.0709-2.6586-3.2332l-4.538-.0125c2.4649,5.1889,5.9378,7.3218,6.1579,7.4529l1.0255.6105,1.0288-.6048c.3364-.1979,8.2412-4.995,8.6887-18.2l.0046-.1842-4.0032-.0111Z"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M170.943,114.991l-4.1275-.0114c.2959,1.4163.6799,2.7015,1.1231,3.8583l4.3566.012c-.6073-1.2947-1.0438-2.6121-1.3522-3.8589Z"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M170.2045,109.6759l.0005-.173-4.0032-.011.0036.1842c.037,1.3055.1498,2.5262.319,3.6718l4.0705.0112c-.2659-1.4976-.3614-2.7978-.3903-3.6833Z"
});

var SvgChasStandard = function SvgChasStandard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 485 485.3",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChasStandard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CHAS Standard.2a30eed6.svg";
export { ForwardRef as ReactComponent };